<template>
  <div
    v-show="showDebug"
    class="c-player-debug-info"
  >
    <div
      v-for="(info, index) in infos"
      :key="index"
    >
      <div class="o-typography__headline5">
        {{ info.heading }}
      </div>
      <div class="c-player-debug-info__values">
        <div v-for="(value, key) in info.values">
          {{ key }}: {{ value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ShowDebugMixin from '@/shared/components/player/mixins/show-debug';

  export default {
    name: 'UiPlayerDebugInfo',
    mixins: [ShowDebugMixin],
    props: {
      options: {
        type: Object,
        required: true,
      },
      currentSettings: {
        type: Object,
        required: true,
      },
      currentProfile: {
        type: Object,
        required: true,
      },
    },
    computed: {
      audio() {
        return {
          id: this.currentSettings.audio.id,
          lang: this.currentSettings.audio.lang,
        };
      },
      infos() {
        return [
          { heading: 'AUDIO', values: this.audio },
          { heading: 'PROFILE', values: this.profile },
          { heading: 'SUBTITLES', values: this.subtitles },
        ];
      },
      isProfileAuto() {
        return this.selectedProfile.name === 'Auto';
      },
      profile() {
        if (this.isProfileAuto) {
          return {
            name: 'auto',
            ...this.getProfileParams(this.currentProfile),
          };
        }

        return {
          ...this.getProfileParams(this.selectedProfile),
        };
      },
      selectedProfile() {
        const property = this.currentSettings.profile.name ? 'name' : 'bandwidth';

        return this.options.profiles.find((profile) => {
          return profile[property] === this.currentSettings.profile[property];
        }) || {};
      },
      subtitles() {
        return this.currentSettings.subtitle;
      },
    },
    beforeDestroy() {
      clearInterval(this.interval);
    },
    methods: {
      formatBandwidth(bandwidth) {
        if (!bandwidth || bandwidth < 0) {
          return '';
        }

        return `${(bandwidth / 10e5).toFixed(1)} Mb/s`;
      },
      formatResolution(width, height) {
        if (!width || !height) {
          return '';
        }

        return `${width} x ${height}`;
      },
      getProfileParams(profile) {
        const { bandwidth, height, id, width } = profile;

        return {
          id,
          bandwidth: this.formatBandwidth(bandwidth),
          resolution: this.formatResolution(width, height),
        };
      },
    },
  };
</script>
